import { createGlobalStyle } from 'styled-components';
import { getTheme } from '../theme';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => getTheme(props.theme?.isDark || false).fonts.primary};
    background-color: ${props => getTheme(props.theme?.isDark || false).colors.background};
    color: ${props => getTheme(props.theme?.isDark || false).colors.text};
    transition: background-color 0.3s ease, color 0.3s ease;
    overflow-x: hidden;
  }

  /* Hacker style effects for dark mode */
  [data-theme="dark"] {
    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: 
        repeating-linear-gradient(
          0deg,
          rgba(25, 184, 136, 0.03) 0px,
          transparent 1px,
          transparent 2px,
          rgba(25, 184, 136, 0.03) 3px
        );
      pointer-events: none;
      z-index: 9999;
      animation: scanline 8s linear infinite;
    }

    &::after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(
        to right,
        transparent,
        rgba(25, 184, 136, 0.5),
        transparent
      );
      pointer-events: none;
      z-index: 10000;
      animation: scanlineMove 8s linear infinite;
    }
  }

  @keyframes scanline {
    0% { transform: translateY(0); }
    100% { transform: translateY(100vh); }
  }

  @keyframes scanlineMove {
    0% { top: 0; opacity: 1; }
    50% { opacity: 0.5; }
    100% { top: 100vh; opacity: 0; }
  }

  /* Glitch effect for dark mode text */
  [data-theme="dark"] .glitch {
    position: relative;
    color: #19B888;
    animation: glitch 0.3s infinite;
  }

  @keyframes glitch {
    0%, 100% {
      text-shadow: 
        0.05em 0 0 #19B888,
        -0.05em -0.025em 0 #FF395D,
        0.025em 0.05em 0 #39ACFF;
    }
    15% {
      text-shadow: 
        0.05em 0 0 #19B888,
        -0.05em -0.025em 0 #FF395D,
        0.025em 0.05em 0 #39ACFF;
    }
    16% {
      text-shadow: 
        -0.05em -0.025em 0 #19B888,
        0.025em 0.025em 0 #FF395D,
        -0.05em -0.05em 0 #39ACFF;
    }
    49% {
      text-shadow: 
        -0.05em -0.025em 0 #19B888,
        0.025em 0.025em 0 #FF395D,
        -0.05em -0.05em 0 #39ACFF;
    }
    50% {
      text-shadow: 
        0.025em 0.05em 0 #19B888,
        0.05em 0 0 #FF395D,
        0 -0.05em 0 #39ACFF;
    }
    99% {
      text-shadow: 
        0.025em 0.05em 0 #19B888,
        0.05em 0 0 #FF395D,
        0 -0.05em 0 #39ACFF;
    }
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => getTheme(props.theme?.isDark || false).colors.surface};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => getTheme(props.theme?.isDark || false).colors.primary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => getTheme(props.theme?.isDark || false).colors.primaryDark};
  }

  /* Selection styling */
  ::selection {
    background: ${props => getTheme(props.theme?.isDark || false).colors.primary};
    color: ${props => getTheme(props.theme?.isDark || false).colors.background};
  }
`;

export default GlobalStyles;

